module.exports = __webpack_public_path__ + "static/img/shuidi.06f8123.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/shuidi.png
// module id = yRog
// module chunks = 1